module.exports = __webpack_public_path__ + "static/banner-157314c2d65dbb27e857b60d8407fa6f.gif";